import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';
import { OfbizListService } from '../ofbiz-list/ofbiz-list.service';
import { Cell } from 'angular2-smart-table';

@Component({
  selector: 'ubs-ofbiz-cell-dropdown',
  template: `
    <div>{{renderValue}}</div>
  `,
  styleUrls: ['./ofbiz-cell-dropdown.component.scss']
})
export class OfbizCellDropdownComponent implements  ViewCell,OnInit {
  @Input() cell: Cell; // Cell type is not defined in the original code, assuming it's a generic type
  @Input() value: string | number;
  @Input() rowData: any;
  renderValue: string;
  
  constructor(private ofbizListService:OfbizListService) {

   }

  ngOnInit(): void {
    this.value = this.cell.getValue();
    console.log({TrackDropdown:this.rowData})
    this.renderValue = this.value.toString();
    this.rowData = this.cell.getRow().getData();
  }

}
